// Terbebas: product analytics is not wired yet (will become per-store
// config). This no-op stub preserves the Mixpanel call sites so the
// legacy tracking calls are harmless.
export let Mixpanel = {
	track: (_event: string, _props?: Record<string, unknown>) => {},
	identify: (_id?: string) => {},
	reset: () => {},
	get_distinct_id: () => '',
};
